import React from 'react';
import { Flex, Spinner, Center } from 'ui';
import { DocumentsCard } from './components';
import { useController } from './hooks';
import { style as s } from './ProofDocuments.style';

export const ProofDocuments = () => {
  const {
    isLoading,
    isEmployee,
    isBusinessOwner,
    taxSituation,
    bankStatement,
    proofOfIncome,
    identification,
    proofOfAddress,
    proofOfActivity,
    showTaxSituation,
  } = useController();

  return (
    <Center {...s.container}>
      {isLoading && (
        <Flex>
          <Spinner {...s.spinner} />
        </Flex>
      )}
      {!isLoading && (
        <>
          <DocumentsCard {...identification} />
          <DocumentsCard {...proofOfAddress} />
          {isEmployee
            && <DocumentsCard {...proofOfIncome} />}
          {!isEmployee
            && <DocumentsCard {...bankStatement} />}
          {isBusinessOwner
            && <DocumentsCard {...proofOfActivity} />}
          {showTaxSituation
            && <DocumentsCard {...taxSituation} />}
        </>
      )}
    </Center>
  );
};
